import VuexCommonMix from '@/store/vuexCommonMix'
import { queryeGetLoginUrl, queryeCheckLogin, queryStudentList, deleteStudent } from '@/api'
export default {
  components: {},
  mixins: [VuexCommonMix],
  props: [],
  name: 'personalDetails-page',
  data () {
    return {
      user: {
        eduStudentId: '',
        gender: '',
        headerUrl: '',
        nickName: '',
        phone: '',
        studentHeaderUrl: '',
        studentNickName: '',
        studentRealName: '',
        userId: '',
        userType: ''
      },
      sellOrderList: [],
      showUnbingDialog: false,
      Unbingitem: null
    }
  },
  created () {
    this.getUseInfo()
  },
  mounted () {},
  destroyed () {},
  filters: {
    getstatus (status) {
      if (status === '1' || status === 1) {
        return '上课中'
      } else if (status === 2 || status === '2') {
        return '未上课'
      } else {
        return '已结课'
      }
    }
  },
  methods: {
    async getLoginUrl () {
      // 获取不同的参数入口
      // const type = this.getQueryString('type')
      const { data } = await queryeGetLoginUrl({ redirect: 'https://gec-api.gecacademy.cn/evaluation/user/wx/callBack?userType=1' })
      window.location.href = data
    },
    async getUseInfo () {
      const { data } = await queryeCheckLogin()
      this.initUserInfo(data)
      this.user = data
      // 如果已经登录有用户信息则
      if (this.user && this.user.userId) {
        this.getStudentCourse()
      } else {
        this.getLoginUrl()
      }
    },

    async getStudentCourse () {
      const { data, error } = await queryStudentList()
      if (error.returnCode === 1) {
        // 关闭页面
        setTimeout(() => {
          document.addEventListener(
            'WeixinJSBridgeReady',
            function () {
              window.WeixinJSBridge.call('closeWindow')
            },
            false
          )
          // 苹果
          window.WeixinJSBridge.call('closeWindow')
        }, 1200)
      } else {
        this.sellOrderList = data.sellOrderList
      }
    },
    getQueryString (name) {
      const url1 = window.location.search
      const url = decodeURI(url1)
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      const r = url.substr(1).match(reg)
      if (r != null) {
        return unescape(r[2])
      };
      return null
    },
    async sureUnbingitem () {
      await deleteStudent({ sellOrderId: this.Unbingitem.sellOrderId, classId: this.Unbingitem.classId })
      this.showUnbingDialog = false
      this.Unbingitem = null
      this.getStudentCourse()
    },
    async unbundling (item) {
      this.showUnbingDialog = true
      this.Unbingitem = item
    },
    goProjectList (item) {
      this.$router.push({ path: '/personalProjectList', query: { sellOrderId: item.sellOrderId, classId: item.classId } })
    },
    bindingStudent () {
      this.$router.push({ path: '/bindingStudents' })
    }
  }
}
